<template>
  <router-link to="/" class="logo-link" aria-label="Ir al inicio">
    <span class="logo-glow">
      <img
        src="@/assets/logo_ksx.svg"
        alt=""
        :class="{ 'logo-img--desktop': !device.isMobile, 'logo-img--mobile': device.isMobile }"
        class="logo-img"
        width="160"
        height="160"
        decoding="async"
        fetchpriority="high"
      />
    </span>
  </router-link>
</template>

<script>
export default {
  props: {
    device: Object,
  },
  name: 'LogoComponent',
}
</script>

<style scoped>
.logo-link {
  --logo-primary: var(--primary-color, #c9a962);
  --logo-surface: var(--card-bg, #0d100e);
  display: flex;
  align-items: center;
  text-decoration: none;
  border-radius: 12px;
  outline-offset: 3px;
  background: var(--logo-surface);
}

.logo-link:focus-visible {
  outline: 2px solid var(--logo-primary);
}

/* Contenedor: mismo fondo que la barra evita «línea» clara por transparencia / subpíxeles */
.logo-glow {
  position: relative;
  display: inline-block;
  border-radius: 10px;
  overflow: hidden;
  line-height: 0;
  font-size: 0;
  isolation: isolate;
  background: var(--logo-surface);
  animation: logo-silhouette-glow 2.6s ease-in-out infinite;
}

.logo-glow::before {
  display: none;
}

/* Destello desactivado: el degradado + mix-blend-mode marcaban franja clara bajo el raster del SVG */
.logo-glow::after {
  display: none;
}

.logo-img {
  display: block;
  flex-shrink: 0;
  height: auto;
  aspect-ratio: 1;
  object-fit: contain;
  object-position: center;
  border-radius: 8px;
  position: relative;
  z-index: 0;
  background-color: var(--logo-surface);
  box-shadow: var(--logo-img-shadow, 0 2px 10px rgba(0, 0, 0, 0.28));
  filter: brightness(1.02) saturate(1);
  transform: translateZ(0);
  backface-visibility: hidden;
}

/* Fallback si color-mix no está disponible: mismos valores que --primary */
@supports not (color: color-mix(in srgb, red, blue)) {
  .logo-img {
    box-shadow: 0 4px 14px rgba(0, 0, 0, 0.35);
  }
}

@keyframes logo-silhouette-glow {
  0%,
  100% {
    filter: drop-shadow(0 0 4px rgba(201, 169, 98, 0.18));
  }
  50% {
    filter: drop-shadow(0 0 12px rgba(201, 169, 98, 0.42)) drop-shadow(0 0 22px rgba(201, 169, 98, 0.2));
  }
}

@media (prefers-reduced-motion: reduce) {
  .logo-glow {
    animation: none;
    filter: drop-shadow(0 0 10px rgba(201, 169, 98, 0.28));
  }
}

/* Desktop / tablet: escala desde tokens (--nav-logo-desktop-width) */
.logo-img--desktop {
  width: var(--nav-logo-desktop-width, clamp(2rem, 4vw, 2.5rem)) !important;
  height: auto !important;
  max-height: none !important;
}

/* Móvil: mismo orden de magnitud que --nav-icon-touch-min en la barra */
.logo-img--mobile {
  width: var(--nav-logo-mobile-size, 2.25rem) !important;
  height: var(--nav-logo-mobile-size, 2.25rem) !important;
  max-height: none !important;
}

@media (max-width: 768px) {
  .logo-img {
    filter: none;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.3);
  }

  .logo-glow {
    animation: none;
    filter: drop-shadow(0 0 6px rgba(201, 169, 98, 0.18));
  }
}
</style>
